import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import ApiService from './api.service.abstract';
import { APP_CONFIG } from '../../../app-config';
import { IAirline } from '@pulpo/pulpo-models';
import { RouteReuseStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AirlineService extends ApiService<IAirline> {
  airlinesChangedSubject = new Subject<IAirline[]>();
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient,
    routeReuse: RouteReuseStrategy
  ) {
    super(environment, http, 'flight/api/airlines', routeReuse);
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:4300';
    }
  }
}
